module.exports = __webpack_public_path__ + "static/media/5DPO1.ce9209a6.jpg";